import { render, staticRenderFns } from "./BarComponent.vue?vue&type=template&id=499a30fc&scoped=true&"
import script from "./BarComponent.vue?vue&type=script&lang=js&"
export * from "./BarComponent.vue?vue&type=script&lang=js&"
import style0 from "./BarComponent.vue?vue&type=style&index=0&id=499a30fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a30fc",
  null
  
)

export default component.exports